import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ProductSaleMutationVoidInput,
  ProductSaleMutationInput,
  ProductSaleMutationUpdateInput,
  ProductSaleMutationCompleteInput,
  ProductSalesModel,
} from './model';

export function useCreateProductSale(
  options?: UseMutationOptions<
    ApiResult<ProductSalesModel>,
    ApiError,
    ProductSaleMutationInput
  >,
) {
  return useMutation<
    ApiResult<ProductSalesModel>,
    ApiError,
    ProductSaleMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'product-sales',
      method: 'POST',
      body,
    });
  }, options);
}

export function useUpdateProductSale(
  options?: UseMutationOptions<
    ApiResult<ProductSalesModel>,
    ApiError,
    ProductSaleMutationUpdateInput
  >,
) {
  return useMutation<
    ApiResult<ProductSalesModel>,
    ApiError,
    ProductSaleMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-sales/${body.id}`,
      method: 'PUT',
      body: body.body,
    });
  }, options);
}

export function useVoidProductSale(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductSaleMutationVoidInput
  >,
) {
  return useMutation<ApiResult<any>, ApiError, ProductSaleMutationVoidInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `product-sales/${body.id}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useCompleteProductSale(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductSaleMutationCompleteInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    ProductSaleMutationCompleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-sales/${body.id}/complete`,
      method: 'PATCH',
    });
  }, options);
}

export function useRevertCompleteProductSale(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductSaleMutationCompleteInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    ProductSaleMutationCompleteInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `product-sales/${body.id}/revert-complete`,
      method: 'PATCH',
    });
  }, options);
}
